import React, { Component } from "react";
import "../Styles/SvgCommand.css";

class ShowCommand extends Component {
  state = { canShowForm: false };
  
  render() {
    
    return (     
      <svg x="0px" y="0px" viewBox="0 0 297 297" style ={{ marginTop: "3px", marginBottom: "-3px"  }} className={"svg" + " " + this.props.className}>
        <g>
	        <path d="M294.908,142.226c-0.566-0.756-14.169-18.72-38.883-36.693c-32.842-23.886-70.023-36.511-107.524-36.511
		      c-37.501,0-74.683,12.625-107.525,36.51C16.261,123.506,2.658,141.47,2.092,142.226c-2.789,3.718-2.789,8.831,0,12.549
		      c0.566,0.756,14.169,18.72,38.884,36.694c32.843,23.885,70.024,36.51,107.525,36.51c37.502,0,74.683-12.625,107.524-36.511
		      c24.714-17.974,38.316-35.938,38.883-36.693C297.697,151.057,297.697,145.943,294.908,142.226z M207.065,148.5
		      c0,32.292-26.271,58.564-58.563,58.564S89.938,180.792,89.938,148.5s26.271-58.563,58.563-58.563S207.065,116.208,207.065,148.5z
		      M24.152,148.499c8.936-9.863,28.83-29.278,57.591-43.046c-8.034,12.415-12.721,27.19-12.721,43.047
		      c0,15.914,4.719,30.738,12.807,43.181c-9.538-4.566-18.878-10.143-27.995-16.724C39.936,164.925,29.835,154.779,24.152,148.499z
		      M243.167,174.957c-9.117,6.581-18.457,12.156-27.993,16.724c8.087-12.442,12.806-27.268,12.806-43.181
		      s-4.719-30.738-12.806-43.181c9.536,4.567,18.876,10.143,27.993,16.724c13.897,10.032,23.998,20.178,29.68,26.457
		      C267.161,154.783,257.062,164.927,243.167,174.957z"/>
	        <circle cx="148.501" cy="148.5" r="17.255"/>
        </g>
      </svg>);

    /*<svg className="svg">
          <rect x="5" y="9" width="16" height="1.5" rx="1" />
          <rect x="12" y="2" width="1.5" height="16" rx="1" />
        </svg>
        {this.state.canShowForm && detailForm}
        */
  }
}

export default ShowCommand;
